import axios from "axios";
import { message } from 'antd';
import qs from 'qs'
import { StorageModule } from "../modules/storage";
// import { baseUrl } from "./config";
// 设置请求头
let headers: any = {
  // Authorization: StorageModule.getChatUser().token,
  Authorization: StorageModule.getUser().token,
};
if (StorageModule.getUser().token) {
  // headers.Authorization = StorageModule.getUser().token
} else {
  // window.location.hash = '#/auth'
  // window.location.reload()
}
//过滤请求
// if(headers.Authorization !== '') {
axios.interceptors.request.use(
  (config: any) => {
    //解决第一次登录后blob类型加不上的问题
    if (config.data?.unused === 0) {
      config.headers.responseType = 'blob'
    }
    if (config.headers.hasOwnProperty("responseType")) {
      config.responseType = config.headers.responseType;
    }
    config.url = process.env.REACT_APP_API_URL + config.url
    //get 数组参数
    if (config.method === 'get') {
      config.paramsSerializer = function (params: any) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    config.headers = {
      ...headers,
      ...config.headers
    };
    // config.timeout = 10 * 1000; //请求响应时间
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// }

let timer: any = null
let num: any = 0
const logOut = () => {
  clearTimeout(timer)
  timer = setTimeout(() => {
    message.info('验证失效，请重新登录！')
    window.location.hash = '#/login'
  }, 500)
}

// 添加响应拦截器
axios.interceptors.response.use(
  (response: any) => { 
    if (response.config.headers.hasOwnProperty("responseType")) {
      return Promise.resolve(response);
    } else {
      return Promise.resolve(response.data);
    }
  },
  error => {
    if (error && error.response) {
      let res = { code: null };
      res.code = error.response.status;
      if (res.code === 401) {
        // 暂时不处理
        // logOut()
        // num = num + 1
        // if (num === 1) {
        //   message.error(error.response.data.state.description)
        // }
        window.location.hash = '#/login';
        num=0
        return Promise.resolve({});
      }else if(res.code === 404){
        return Promise.resolve(res);
      } else {
        try {
          if (error.response.config.headers.noerr === '1') {
            return Promise.resolve(error.response.data);
          } else {
            message.error(error.response.data.state.description)
          }
        } catch (err) { }
      }
      return Promise.reject(res);
    }
    return Promise.reject(error);
  }
);

export default function request(method: any, url: any, data?: any, callback?: any, noerr?: boolean) {
  //暴露 request 给我们好API 管理
  method = method.toLocaleLowerCase(); //封装RESTful API的各种请求方式 以 post get delete为例
  if (method === "post") {
    return axios.post(url, data, {
      headers: { noerr: noerr ? '1' : '0' }
    }); //axios的post 默认转化为json格式
  } else if (method === "posttxt") {
    return axios.post(url, data, {
      headers: { 'Content-Type': 'text/plain' }
    });
  } else if (method === "get") {
    return axios.get(url, { params: data });
  } else if (method === "head") {
    return axios.head(url, { params: data });
  } else if (method === "delete") {
    return axios.delete(url, { params: data });
  } else if (method === 'put') {
    return axios.put(url, data)
  } else if (method === 'puttext') {
    return axios.put(url, data, { headers: { 'Content-Type': 'text/plain' } })
  } else if (method === 'posttext') {
    return axios.post(url, data, { headers: { 'Content-Type': 'text/plain' } })
  } else if (method === "getblob") {
    return axios.get(url, { data: { unused: 0 }, headers: { responseType: "blob" } });
  } else if (method === 'file') {
    return axios.put(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
  } else if (method === 'progress') {
    return axios({
      url, method: 'post', data, onUploadProgress(load: any) {
        callback(load)
      }
    })
  }
}
